define(function(require, exports, module) {
    'use strict';

    const util = require('utils');
    const Class = require('Class');
    const AbstractProvider = require('common/addressLookupSwiss/sourceProviders/abstractProvider');

    module.exports = Class.create(AbstractProvider, {
        streetRegEx: new RegExp(/^(\p{Letter}*)$/u),

        prepareRequest: function(searchText, prevSearchResult) {
            const data = AbstractProvider.prototype.prepareRequest(searchText, prevSearchResult);

            data.request = {
                ...data.request,
                Streetname: searchText,
                TownName: prevSearchResult.city
            };

            return data;
        },

        format: function(row) {
            return this.highlightResult(row.streetName);
        },

        /**
         * @override
         */
        isValid: function(searchText) {
            return searchText.length >= 2 && this.streetRegEx.test(searchText);
        },

        sort: function(rows) {
            return rows.sort(function(row1, row2) {
                return util.predicate.stringPredicate(row1.streetName, row2.streetName);
            });
        }
    });
});
